/**
 * Created by afuhr on 20.09.2016.
 */
import {IPayloadAction} from "../../actions";
import {DepotActions} from "../../actions/depot.actions";
import {IDepotRecord} from "./depot.types";
import {INITIAL_STATE} from "./depot.initial-state";


export function depotReducer(state: IDepotRecord = INITIAL_STATE,
                             action: IPayloadAction): IDepotRecord {

  switch (action.type) {
    case DepotActions.SELECT_DEPOT:
      console.info("Select depot", [action]);
      return state.merge({
        selectedDepot: action.payload
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/redux-store/depot/depot.reducer.ts